import React from "react";
import LeftMenuOrderPage from "../../constant/LeftMenuOrderPage";
import Topbar from "../../constant/Topbar/Topbar";

const OrderInnerLayout = ({ children }) => {
  return (
    <div
      style={{
        minHeight: 834,
        background: "#F3F3F3",
      }}
    >
      <Topbar />
      <ContainerBox children={children} />
    </div>
  );
};

const ContainerBox = ({ children }) => (
  <div
    style={{
      display: "flex",
    }}
  >
    <LeftMenuOrderPage />

    <main>{children}</main>
  </div>
);

export default OrderInnerLayout;
